import { AuthContext as e, AuthorizedApiBase as t } from "@urbanx/agx.auth.client";
import n from "axios";
import { c as r } from "react/compiler-runtime";
import { jsx as i } from "react/jsx-runtime";
import { createContext as a, useContext as o, useEffect as s, useState as c } from "react";
import { useMutation as l, useQuery as u, useQueryClient as d } from "@tanstack/react-query";
//#region src/Client.ts
function f(e) {
	return e instanceof Date ? e.toISOString() : String(e);
}
var p = class extends t {
	instance;
	baseUrl;
	jsonParseReviver;
	constructor(e, t) {
		super(), this.instance = t ?? n.create(), this.baseUrl = e ?? "http://127.0.0.1:7075/Domain";
	}
	getAgencyCode(e, t) {
		let r = this.baseUrl + "/GetAgencyCode";
		if (r += "?", e == null) throw new globalThis.Error("The parameter 'agencyId' must be defined and cannot be null.");
		r += "agencyId=" + encodeURIComponent(f(e)) + "&", r = r.replace(/[?&]$/, "");
		let i = {
			method: "GET",
			url: r,
			headers: { Accept: "application/json" },
			signal: t
		};
		return this.transformOptions(i).then((e) => this.instance.request(e)).catch((e) => {
			if (n.isAxiosError(e) && e.response) return e.response;
			throw e;
		}).then((e) => this.transformResult(r, e, (e) => this.processGetAgencyCode(e)));
	}
	processGetAgencyCode(e) {
		let t = Object.fromEntries(Object.entries(e.headers ?? {}).map(([e, t]) => [e, t]));
		return e.status === 200 ? Promise.resolve(e.data) : e.status === 401 || e.status === 404 ? g("No description", e.status, e.data, t) : e.status === 204 ? Promise.resolve(null) : g("An unexpected server error occurred.", e.status, e.data, t);
	}
	getDomainListingFee(e, t, r, i, a, o) {
		let s = this.baseUrl + "/GetDomainListingFee";
		if (s += "?", e == null) throw new globalThis.Error("The parameter 'suburb' must be defined and cannot be null.");
		if (s += "suburb=" + encodeURIComponent(f(e)) + "&", t == null) throw new globalThis.Error("The parameter 'state' must be defined and cannot be null.");
		if (s += "state=" + encodeURIComponent(f(t)) + "&", r == null) throw new globalThis.Error("The parameter 'postcode' must be defined and cannot be null.");
		s += "postcode=" + encodeURIComponent(f(r)) + "&", i != null && (s += "estimatedValue=" + encodeURIComponent(f(i)) + "&"), a != null && (s += "isRural=" + encodeURIComponent(f(a)) + "&"), s = s.replace(/[?&]$/, "");
		let c = {
			method: "GET",
			url: s,
			headers: { Accept: "application/json" },
			signal: o
		};
		return this.transformOptions(c).then((e) => this.instance.request(e)).catch((e) => {
			if (n.isAxiosError(e) && e.response) return e.response;
			throw e;
		}).then((e) => this.transformResult(s, e, (e) => this.processGetDomainListingFee(e)));
	}
	processGetDomainListingFee(e) {
		let t = Object.fromEntries(Object.entries(e.headers ?? {}).map(([e, t]) => [e, t]));
		return e.status === 200 ? Promise.resolve(e.data) : e.status === 400 || e.status === 401 || e.status === 404 ? g("No description", e.status, e.data, t) : e.status === 204 ? Promise.resolve(null) : g("An unexpected server error occurred.", e.status, e.data, t);
	}
	setAgencyCode(e, t) {
		let r = this.baseUrl + "/SetAgencyCode", i = {
			method: "POST",
			url: r,
			headers: { "Content-Type": "application/json" },
			data: JSON.stringify(e),
			signal: t
		};
		return this.transformOptions(i).then((e) => this.instance.request(e)).catch((e) => {
			if (n.isAxiosError(e) && e.response) return e.response;
			throw e;
		}).then((e) => this.transformResult(r, e, (e) => this.processSetAgencyCode(e)));
	}
	processSetAgencyCode(e) {
		let t = Object.fromEntries(Object.entries(e.headers ?? {}).map(([e, t]) => [e, t]));
		return e.status === 200 ? Promise.resolve(null) : e.status === 400 || e.status === 401 || e.status === 404 ? g("No description", e.status, e.data, t) : e.status === 204 ? Promise.resolve(null) : g("An unexpected server error occurred.", e.status, e.data, t);
	}
}, m = /* @__PURE__ */ function(e) {
	return e.Act = "Act", e.Nsw = "Nsw", e.Nt = "Nt", e.Qld = "Qld", e.Sa = "Sa", e.Tas = "Tas", e.Wa = "Wa", e.Vic = "Vic", e;
}({}), h = class extends Error {
	message;
	status;
	response;
	headers;
	result;
	constructor(e, t, n, r, i) {
		super(), this.message = e, this.status = t, this.response = n, this.headers = r, this.result = i;
	}
	isDomainApiException = !0;
	static isDomainApiException(e) {
		return e.isDomainApiException === !0;
	}
};
function g(e, t, n, r, i) {
	throw i ?? new h(e, t, n, r, null);
}
//#endregion
//#region src/useClientContext.tsx
var _ = "domain";
function v(e) {
	let t = Object.getPrototypeOf(e);
	for (let n of Object.getOwnPropertyNames(t)) {
		let r = t[n];
		typeof r == "function" && n !== "constructor" && (e[n] = r.bind(e));
	}
	return e;
}
var y = (e, t, n) => {
	let r = new p(e);
	return r.setAuthConfig(t, n), v(r);
}, b = ({ baseApiUri: e, localUris: t }) => {
	if (!e) throw console.error("Base API URI is undefined"), Error("Base API URI is undefined");
	return t?.[_] || `${e}/${_}`;
}, x = (t) => {
	let n = r(10), { agxConfig: i } = t, { getAuthToken: a } = o(e), l, u, d;
	n[0] !== i || n[1] !== a ? (l = b(i), u = c, d = y(l, a, i), n[0] = i, n[1] = a, n[2] = l, n[3] = u, n[4] = d) : (l = n[2], u = n[3], d = n[4]);
	let [f, p] = u(d), m, h;
	return n[5] !== i || n[6] !== l || n[7] !== a ? (m = () => {
		let e = y(l, a, i);
		p(e);
	}, h = [
		a,
		i,
		l
	], n[5] = i, n[6] = l, n[7] = a, n[8] = m, n[9] = h) : (m = n[8], h = n[9]), s(m, h), f;
}, S = a({}), C = (e) => {
	let t = r(5), { appConfig: n, children: a } = e, o;
	t[0] === n ? o = t[1] : (o = { agxConfig: n }, t[0] = n, t[1] = o);
	let s = x(o);
	if (!s) return null;
	let c;
	return t[2] !== s || t[3] !== a ? (c = /* @__PURE__ */ i(S.Provider, {
		value: s,
		children: a
	}), t[2] = s, t[3] = a, t[4] = c) : c = t[4], c;
}, w = (e, t) => {
	let n = r(13), i = t === void 0 || t, a = o(S), s;
	n[0] === e ? s = n[1] : (s = ["getAgencyCode", e], n[0] = e, n[1] = s);
	let c = s, l;
	n[2] !== e || n[3] !== a ? (l = (t) => {
		let { signal: n } = t;
		return a.getAgencyCode(e, n);
	}, n[2] = e, n[3] = a, n[4] = l) : l = n[4];
	let d = i && !!a, f;
	n[5] !== c || n[6] !== l || n[7] !== d ? (f = {
		queryKey: c,
		queryFn: l,
		enabled: d
	}, n[5] = c, n[6] = l, n[7] = d, n[8] = f) : f = n[8];
	let { data: p, isPending: m, isError: h } = u(f), g;
	return n[9] !== p || n[10] !== h || n[11] !== m ? (g = {
		data: p,
		isPending: m,
		isError: h
	}, n[9] = p, n[10] = h, n[11] = m, n[12] = g) : g = n[12], g;
}, T = () => {
	let e = r(2), t = d(), n;
	return e[0] === t ? n = e[1] : (n = async (e) => {
		await t.invalidateQueries({ queryKey: ["getAgencyCode", e] });
	}, e[0] = t, e[1] = n), n;
}, E = (e, t, n, i, a, s) => {
	let c = r(21), l = s === void 0 || s, d = o(S), f;
	c[0] !== i || c[1] !== a || c[2] !== n || c[3] !== t || c[4] !== e ? (f = [
		"getDomainListingFee",
		e,
		t,
		n,
		i,
		a
	], c[0] = i, c[1] = a, c[2] = n, c[3] = t, c[4] = e, c[5] = f) : f = c[5];
	let p = f, m;
	c[6] !== d || c[7] !== i || c[8] !== a || c[9] !== n || c[10] !== t || c[11] !== e ? (m = (r) => {
		let { signal: o } = r;
		return d.getDomainListingFee(e, t, n, i, a, o);
	}, c[6] = d, c[7] = i, c[8] = a, c[9] = n, c[10] = t, c[11] = e, c[12] = m) : m = c[12];
	let h = l && !!d, g;
	c[13] !== p || c[14] !== m || c[15] !== h ? (g = {
		queryKey: p,
		queryFn: m,
		enabled: h
	}, c[13] = p, c[14] = m, c[15] = h, c[16] = g) : g = c[16];
	let { data: _, isPending: v, isError: y } = u(g), b;
	return c[17] !== _ || c[18] !== y || c[19] !== v ? (b = {
		data: _,
		isPending: v,
		isError: y
	}, c[17] = _, c[18] = y, c[19] = v, c[20] = b) : b = c[20], b;
}, D = () => {
	let e = r(2), t = d(), n;
	return e[0] === t ? n = e[1] : (n = async (e, n, r, i, a) => {
		await t.invalidateQueries({ queryKey: [
			"getDomainListingFee",
			e,
			n,
			r,
			i,
			a
		] });
	}, e[0] = t, e[1] = n), n;
}, O = (e) => {
	let t = r(11), n;
	t[0] === e ? n = t[1] : (n = e === void 0 ? {} : e, t[0] = e, t[1] = n);
	let { onSuccess: i, onError: a } = n, s = o(S), c;
	t[2] === s ? c = t[3] : (c = async (e) => s.setAgencyCode(e), t[2] = s, t[3] = c);
	let u;
	t[4] !== a || t[5] !== i || t[6] !== c ? (u = {
		mutationFn: c,
		onSuccess: i,
		onError: a
	}, t[4] = a, t[5] = i, t[6] = c, t[7] = u) : u = t[7];
	let { mutateAsync: d, isPending: f } = l(u), p;
	return t[8] !== d || t[9] !== f ? (p = {
		setAgencyCode: d,
		setAgencyCodePending: f
	}, t[8] = d, t[9] = f, t[10] = p) : p = t[10], p;
};
//#endregion
export { S as DomainApiContext, h as DomainApiException, C as DomainApiProvider, p as DomainClient, _ as DomainRoute, m as State, x as useDomainClientContext, w as useGetAgencyCode, E as useGetDomainListingFee, T as useInvalidateUseGetAgencyCode, D as useInvalidateUseGetDomainListingFee, O as useSetAgencyCode };
